//判断是否是生产环境
var isPro = process.env.NODE_ENV === 'production' //process.env.NODE_ENV用于区分是生产环境还是开发环境
//根据环境不同导出不同的baseURL
module.exports = {
    baseURL: isPro ? 'http://admin.wzyangyu.com': '/apis'
}


//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 0